import axios from "axios"
import utils from "../utils";

const instance = axios.create({
    baseURL: utils.baseUrl + utils.api,
    headers: {
        // "Content-type": "application/json;charset=UTF-8",
        "Accept": "application/json",
    },
    withCredentials: true,
})

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessTkn')
        if(token !== null){
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default instance